import { LandlordBooking, TenantBooking } from '../../../types/bookings';
import BookingCheckInStage from '../BookingStage/BookingCheckInStage/BookingCheckInStage';
import BookingContractStage from '../BookingStage/BookingContractStage/BookingContractStage';
import BookingCreditAnalysisStage from '../BookingStage/BookingCreditAnalysisStage/BookingCreditAnalysisStage';
import BookingRequestStage from '../BookingStage/BookingRequestStage/BookingRequestStage';
import BookingStagesInformation from '../BookingStagesInformation';
import { StyledStageWrapper, StyledWrapper } from './BookingStages.styles';

export const BookingStages = ({
  booking,
}: {
  booking: LandlordBooking | TenantBooking;
}) => {
  return (
    <StyledWrapper>
      <StyledStageWrapper>
        <BookingRequestStage stage={booking.stage} />
        <BookingCreditAnalysisStage stage={booking.stage} />
        <BookingContractStage stage={booking.stage} />
        <BookingCheckInStage stage={booking.stage} />
      </StyledStageWrapper>
      <BookingStagesInformation booking={booking} />
    </StyledWrapper>
  );
};

export default BookingStages;
